export const genderName = {
  MALE: "Male",
  FEMALE: "Female",
};

export const genderAcronym = {
  MALE: "M",
  FEMALE: "F",
};
